<template>
  <div class="container-title">
      <div class="title-main">{{title}}</div>
      <div class="title-intro" v-if="intro">{{intro}}</div>
  </div>
</template>

<script>
  // import { apiName } from '../../request/api'

  export default {
    components: {

    },
    name: 'Index',
    props: {
      title: String,
      intro: String,
    },
    data() {
      return {
        loading: false
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {},
    }
  }
</script>

<style scoped>
.container-title{
    width: 100%;
    margin-bottom: 16px;
}
.title-main{
    font-size: 24px;
    font-weight: bold;
    color: #489D80;
}
.title-intro{
    font-size: 14px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    white-space: nowrap;
    /* margin-top: 4px; */

}
</style>